import { createFileRoute } from "@tanstack/react-router"
import Availability from "~/pages/sales-operations/availability"
import { usePageTracking } from "../../../hooks/usePageTracking"

export const Route = createFileRoute("/_auth/insights/availability")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Availability")
  return <Availability />
}
